// src/components/page/home/DateScheduleView.jsx
import React from 'react';
import { motion } from 'framer-motion';
import GroupScheduleGrid from '@/components/schedule/GroupScheduleGrid';
import { buildGroupRows } from '@/lib/dateUtils';
import RandomMessage from "@/components/fun/messages/RandomMessage";

const DateScheduleView = ({ filteredSchedules, selectedDate, groupModes }) => {
  const safeSchedules = Array.isArray(filteredSchedules) ? filteredSchedules : [];
  const groups = [...new Set(safeSchedules.map(s => s.group_name))];
  const groupRows = buildGroupRows(groups);

  const hasData = safeSchedules.some(
    s => (s.group_name && s.group_name.trim() !== '') && (s.subject || s.teacher || s.room)
  );

  if (!hasData) {
    return (
      <motion.div className="text-center py-12" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <p className="text-xl font-semibold text-muted-foreground">📭 Сьогодні занять немає</p>
        <div className="mt-24 border-l-4 border-r-4 border-purple-500 pl-4 pr-4 py-3 rounded-md bg-purple-50 dark:bg-purple-900/20 dark:border-purple-400"><RandomMessage /></div>
        <p className="mt-24 text-xs text-muted-foreground italic">
          PS: Ви можете <a href="/support" className="underline hover:text-primary">підтримати проєкт</a>, щоб він розвивався швидше 💙💛
        </p>
      </motion.div>
    );
  }

  return (
    <div className="space-y-4">
      {groupRows.map((groupsInRow, index) => (
        <motion.div key={index} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <GroupScheduleGrid schedules={safeSchedules} groups={groupsInRow} groupModes={groupModes} selectedDate={selectedDate} />
        </motion.div>
      ))}
    </div>
  );
};

export default DateScheduleView;
